/* i18n-scan-ignore-file: datos de maqueta (varias entradas traen description "this is a test") */
import {Button, Col, Form, Modal, Row} from 'react-bootstrap'
import {FormattedMessage, defineMessages} from 'react-intl'

const M = defineMessages({
  title: {id: 'admin.groups.modal.create.title', defaultMessage: 'Create a new group'},
  name: {id: 'admin.groups.field.name', defaultMessage: 'Name:'},
  color: {id: 'admin.groups.field.color', defaultMessage: 'Color:'},
  createGroup: {id: 'admin.groups.action.create', defaultMessage: 'CREATE GROUP'},
})

const FILTERS_NAME_ARR = [
  {name: 'Agentes Independientes', description: 'this is a test', color: 'primary'},
  {name: 'Call Center USA', description: 'this is a test', color: 'dark'},
  {name: 'Contratos', description: '', color: 'light'},
  {name: 'Grupo Roberto Ramirez', description: 'this is a test', color: 'success'},
  {name: 'Operaciones', description: 'this is a test', color: 'warning'},
  {name: 'Procesamiento', description: '', color: 'success'},
  {name: 'Prueba comisiones', description: 'this is a test', color: 'warning'},
  {name: 'Support', description: 'this is a test', color: 'dark'},
]

export const ModalAddManage: React.FC<{isOpen: boolean; onClose: () => void}> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal show={isOpen} onHide={onClose} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage {...M.title} />
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={(e) => e.preventDefault()}>
        <Modal.Body>
          <Row>
            <Col md={6} sm={12}>
              <Form.Group>
                <Form.Label>
                  <FormattedMessage {...M.name} />
                  <small className='text-danger ms-1'>
                    <FormattedMessage id='validation.required' defaultMessage='(required)' />
                  </small>
                </Form.Label>
                <Form.Control />
              </Form.Group>
            </Col>
            <Col md={6} sm={12}>
              <Form.Group>
                <Form.Label>
                  <FormattedMessage {...M.color} />
                  <small className='text-danger ms-1'>
                    <FormattedMessage id='validation.required' defaultMessage='(required)' />
                  </small>
                </Form.Label>
                <Form.Control className='w-50' type='color' />
              </Form.Group>
            </Col>
            <Col md={12} sm={12} className='mt-4'>
              <Form.Group>
                <Form.Label>
                  <FormattedMessage id='common.field.description' defaultMessage='Description' />
                </Form.Label>
                <Form.Control as='textarea' rows={4} />
              </Form.Group>
            </Col>
          </Row>
          <div className='my-5 d-flex align-items-center justify-content-end w-100'>
            <Button size='sm'>
              <i className='bi bi-check fs-3' style={{color: 'inherit'}} />
              <FormattedMessage {...M.createGroup} />
            </Button>
          </div>
          <div>
            <table className='table table-hover'>
              <thead>
                <tr>
                  <th className='fw-bold'>
                    <FormattedMessage id='common.field.name' defaultMessage='Name' />
                  </th>
                  <th className='fw-bold'>
                    <FormattedMessage id='common.field.description' defaultMessage='Description' />
                  </th>
                  <th className='fw-bold text-right'>
                    <FormattedMessage id='common.field.actions' defaultMessage='Actions' />
                  </th>
                </tr>
              </thead>
              <tbody>
                {FILTERS_NAME_ARR.map((fil) => (
                  <tr>
                    <td>{fil.name}</td>
                    <td>{fil.description}</td>
                    <td>
                      <Button variant='outline-primary' size='sm'>
                        <i className='bi bi-pencil' style={{color: 'inherit'}} />
                        <FormattedMessage id='common.action.edit' defaultMessage='Edit' />
                      </Button>
                      <Button variant='outline-danger' className='ms-4' size='sm'>
                        <i className='bi bi-x' style={{color: 'inherit'}} />
                        <FormattedMessage id='common.action.delete' defaultMessage='Delete' />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='outline-secondary'
            onClick={onClose}
            style={{border: '1px solid #dbdfe9'}}
          >
            <FormattedMessage id='common.action.close' defaultMessage='Close' />
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}
